<template>
	<div  class="data-table">
		<div v-if="uid=='none'">
			<div class="menu row-center" style="justify-content:space-between">
				<div class="row-center">
					<span style="font-size:18rem">选择日期：</span>
					<el-date-picker :editable="false" :picker-options="pickerOptions" style="height: 40px !important"
									:clearable="false" class="dateSelect" v-model="date1"
									:type="radio === 'day' ? 'date' : radio"
									:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
					</el-date-picker>

					<div class="radio">
						<el-radio v-model="radio" label="year">年</el-radio>
						<el-radio v-model="radio" label="month">月</el-radio>
						<el-radio v-model="radio" label="day" >日</el-radio>
					</div>
					<div class="btn per" @click="perD" v-if="radio === 'day'">上一日</div>
					<div class="btn per" @click="perM" v-if="radio === 'month'">上一月</div>
					<div class="btn per" @click="perY" v-if="radio === 'year'">上一年</div>
					<el-button class="btn next" plain @click="nextD" v-if="radio === 'day'" :disabled="nextDayDisabled">
						下一日
					</el-button>
					<el-button class="btn next" plain @click="nextM" v-if="radio === 'month'"
							:disabled="nextDayDisabled">
						下一月
					</el-button>
					<el-button class="btn next" plain @click="nextY" v-if="radio === 'year'"
							:disabled="nextDayDisabled">下一年
					</el-button>
				</div>
			</div>
			
			<div class="chartsright" style="width: 100%;height: 45vh;margin-top:30rem;text-align:center">
				<charts id="ComparisonCharts2" :option="LoopOption" v-if="selectedLoops.length>0" ></charts>
				<div class="chartsright" style="width: 100%;height: 45vh;margin-top:30rem;text-align:center" v-else>
					<img  src="../../assets/img/not_found_data.png" alt="" style="margin-top:8%">
				</div>
			</div>
			
			<div class="report">
				<PinnacleTable :routeName="routeName" :tag="uid" :pinnacleInfo="pinnacleInfo" ></PinnacleTable>
			</div>
		</div>
		<div v-else>
			<div class="menu row-center" style="justify-content:space-between" >
				<div class="tit-com">时段电量对比</div>
				<div class="row-center">
					<div>
						<span>第一时间：</span>
						<span>
							<el-date-picker :editable="false" :picker-options="pickerOptions"
											style="width: 160px !important;height: 33px !important;margin-right: 39px;    vertical-align: middle;"
											:clearable="false" class="dateSelect" v-model="date"
											:type="radio === 'day' ? 'date' : radio"
											:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
							</el-date-picker>
						</span>
					</div>
					<div>
						<span>第二时间：</span>
						<span>
							<el-date-picker :editable="false" :picker-options="pickerOptions"
											style="width: 160px !important;height: 33px !important;margin-right: 39px;    vertical-align: middle;"
											:clearable="false" class="dateSelect" v-model="twodate"
											:type="radio === 'day' ? 'date' : radio"
											:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
							</el-date-picker>
						</span>
					</div>
					<div class="radio-3 row-center" style="width: 187px;height: 33px;">
						<div :class="radio=='year'?'active':''" @click="radio='year'">年</div>
						<div :class="radio=='month'?'active':''" @click="radio='month'">月</div>
						<div :class="radio=='day'?'active':''" @click="radio='day'">日</div>
					</div>

				</div>
			</div>
			
			<div class="chartsright" style="width: 100%;height: 45vh;margin-top:30rem;text-align:center">
				<charts id="ComparisonCharts" :option="ComparisonOption" v-if="ishow" ></charts>
				<div class="chartsright" style="width: 100%;height: 45vh;margin-top:30rem;text-align:center" v-else>
					<img  src="../../assets/img/not_found_data.png" alt="" style="margin-top:8%">
				</div>
			</div>
			<div class="report">
				<PinnacleTable :routeName="routeName" :tag="uid" :pinnacleInfo="pinnacleInfo2"></PinnacleTable>
			</div>
		</div>
	</div>
</template>

<script>
	import Curve from "../../chart/Curve";
	import charts from "../../components/Energy/charts";
	import {
		POWER_ANALYSIS_BY_LOOP
	} from "../../api/power";
	import Extremum from "./report/Extremum";
	import Running from "./report/Running";
	import PinnacleTable from "./sheet/PinnacleTable.vue";
	import {
		floatFormat
	} from "../../util/MathUtil";
	import {
		perDay,
		perMonth,
		perYear,
		nextDay,
		monthStart,
		yearStart,
		monthEnd,
		yearEnd,
		nextMonth,
		nextYear,
		dateFormat,
		dayStart,
		dayEnd,
	} from "../../util/DateUtil";
	import CircuitBreakerAging from "./CircuitBreakerAging";
	import PowerTime from "./report/PowerTime";
	import PowerRange from "./report/PowerRange";
	import {INFLUX_QUERY} from "../../api/power"
	import {
		storeInstance
	} from "../../main";

	export default {
		name: "PowerDataBase",
		props: {
			realData: Array,
			options: Array,
			currentLoop: Object, 
			selectedLoops: Array,
			uid:String
		},
		components: {
			Curve,
			Extremum,
			Running,
			CircuitBreakerAging,
			PowerTime,
			PowerRange,
			charts,
			PinnacleTable
		},
		data() {
			let that = this
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				radio: "day",
				date1:new Date(),
				date:new Date(),
				twodate:new Date(),
				xdata:[],
				pinnacleInfo:[],
				pinnacleInfo2:[],
				chartData:[],
				chartTimeData:[],
				loading:false,
				ishow:true,
			};
		},
		computed: {
			ComparisonOption(){
				return {
					// color: ["#0D94FF", "#5AD8A6", "#E8684A", "#5D7092"],
					tooltip: {
						trigger: "axis",
						textStyle:{
					　　	align:'left'
					　　}
					},
					legend: {
						// orient: "vertical", //垂直显示
						// y: "10%", //延Y轴居中
						// x: "right", //居右显示
						icon: "rect",
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							fontSize: 15,
							// fontWeight: 800,
						},
					},
					grid: {
						left: "0%",
						right: "1%",
						bottom: "1%",
						top: "10%",
						containLabel: true,
					},
					xAxis: {
						type: "category",
						// boundaryGap: false,
						data: this.xdata,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
							color: "#CCCCCC",
							width: 1,
							type: "solid",
							},
						},
						axisLabel: {
							//x轴文字的配置
							show: true,
							textStyle: {
							color: "#999999",
							},
						},
					},
					yAxis: {
						type: "value",
						name: "kWh",
					},
					series:  this.chartTimeData
				};
			},
			
			LoopOption(){
				return {
					// color: ["#0D94FF", "#5AD8A6", "#E8684A", "#5D7092"],
					tooltip: {
						trigger: "axis",
						textStyle:{
					　　	align:'left'
					　　　}
					},
					legend: {
						// orient: "vertical", //垂直显示
						// y: "10%", //延Y轴居中
						// x: "right", //居右显示
						icon: "rect",
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							fontSize: 15,
							// fontWeight: 800,
						},
						formatter: function(name){
						　　　　return name.length>15?name.substr(0,15)+"...":name;
						}
					},
					grid: {
						left: "0%",
						right: "1%",
						bottom: "1%",
						top: "10%",
						containLabel: true,
					},
					xAxis: {
						type: "category",
						data: this.xdata,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#CCCCCC",
								width: 1,
								type: "solid",
							},
						},
						axisLabel: {
							//x轴文字的配置
							show: true,
							textStyle: {
								color: "#999999",
							},
						},
					},
					yAxis: {
						type: "value",
						name: "kWh",
					},
					series: this.chartData
				};
			},
			routeNameAndTag() {
				return [this.routeName, this.tag];
			},
			//路由名称
			routeName() {
				return this.$route.params.name;
			},
			//路由tag
			tag() {
				return this.$route.params.tag;
			},
			nextDayDisabled() {
				let timestamp = dateFormat("YY-mm-dd", new Date());
				let endtime = dateFormat("YY-mm-dd", this.date1);
				if (this.radio === "year") {
					timestamp = dateFormat("YY", new Date());
					endtime = dateFormat("YY", this.date1);
				} else if (this.radio === "month") {
					timestamp = dateFormat("YY-mm", new Date());
					endtime = dateFormat("YY-mm", this.date1);
				}
				// console.log(endtime,timestamp)
				if (endtime >= timestamp) {
					return true;
				} else {
					return false;
				}
			},
			
			propsData() {
				return [
					this.uid,
					this.radio,
					this.date,
					this.date1,
					this.twodate,
					this.selectedLoops,
					this.currentLoop
				]
			}
		},
		created() {
			this.LoopData();
			this.LoopTableData()
			// this.ComparisonTableData()
		},
		async mounted() {
			let _this = this
			_this.nextDayDisabled;
			_this.initPowerTimeData();
			for(let i = 0; i < 24; i++){
				this.xdata.push(i+'时')
			}
			let day1 = new Date();
			day1.setDate(day1.getDate() - 1);
			this.date = day1
		},
		watch: {
			uid(b,o){
				this.xdata = []
				let n = this.radio
				this.date = new Date();
				if(n=='day'){
					for(let i = 0; i < 24; i++){
						this.xdata.push(i+'时')
					}
					let day1 = new Date();
					day1.setDate(day1.getDate() - 1);
					this.date = day1
				}
				if(n=='month'){
					for(let i = 1; i <= 31; i++){
						this.xdata.push(i+'日')
					}
					let day1 = new Date();
					day1.setMonth(day1.getMonth() - 1);
					this.date = day1
				}
				if(n=='year'){
					for(let i = 1; i <= 12; i++){
						this.xdata.push(i+'月')
					}
					let day1 = new Date();
					day1.setFullYear(day1.getFullYear() - 1);
					this.date = day1
				}
			},
			radio(n) {
				this.xdata = []
				// this.date = new Date();
				if(n=='day'){
					for(let i = 0; i < 24; i++){
						this.xdata.push(i+'时')
					}
					let day1 = new Date();
					day1.setDate(day1.getDate() - 1);
					this.date = day1
				}
				if(n=='month'){
					for(let i = 1; i <= 31; i++){
						this.xdata.push(i+'日')
					}
					let day1 = new Date();
					day1.setMonth(day1.getMonth()-1);
					this.date = day1
				}
				if(n=='year'){
					for(let i = 1; i <= 12; i++){
						this.xdata.push(i+'月')
					}
					let day1 = new Date();
					day1.setFullYear(day1.getFullYear() - 1);
					this.date = day1
				}
			},
			tag(n, o) {
				this.initPowerTimeData();
			},
			routeName(n) {
				if (n == "Pinnacle") {
					this.radio = "month";
				}
			},
			propsData(n) {
				if(this.uid=='none'){
					this.LoopTableData();
					this.LoopData();
				}else{
					this.ComparisonTableData();
					this.ComparisonData();
				}
				
			}
		},
		methods: {
			async LoopData(){
				if(this.selectedLoops[0]==undefined||this.selectedLoops.length <= 0){
					return
				}

				this.loading = true
				this.chartData = []
				let ids = this.selectedLoops.map(l => l.loopId);
				let start
				let end
				let group

				switch (this.radio) {
					case "day":
						start = dayStart(this.date1)
						end = dayEnd(this.date1)
						group = '1h'
						break
					case "month":
						start = monthStart(this.date1)
						end = monthEnd(this.date1)
						group = '1d'
						break
					case "year":
						start = yearStart(this.date1)
						end = yearEnd(this.date1)
						group = '1m'
						break

				}



				let res = await INFLUX_QUERY(ids, start, end, group,["PA_total"])

				let influxData = res.data.data.influxData

				let list = []

				try {
					this.selectedLoops.forEach(item=>{
						influxData.results[0].series.forEach((serie,index) => {
							let data = []
							serie.values.forEach(val => {
								if(val[4]!=null){
									data.push(floatFormat(val[4],2))
								}else{
									data.push('-')
								}
							})
							if(serie.tags.code.indexOf(item.subLoopUrl)>-1){
								list.push({
									name: item.loopName,
									type: "line",
									data:data
								})
							}else{
								list.push({
									name: item.loopName,
									type: "line",
									data:[]
								})
							}
						})
					})
					
					
				} catch (e) {

				}
				this.chartData = list
				this.loading = false
			},
			async LoopTableData() {
				
				if(this.selectedLoops[0]==undefined||this.selectedLoops.length <= 0){
					return
				}
				let res = await Promise.all(this.selectedLoops.map(l => POWER_ANALYSIS_BY_LOOP(this.date1, this.radio, l.loopId)))
				this.pinnacleInfo = []
				try {
					this.selectedLoops.forEach((l, i) => {
						let resData = res[i].data.data.result
						if (JSON.stringify(resData) != "{}") {
							let year = 'year_' + this.date1.getFullYear()
							let month = 'month_' + (this.date1.getMonth() + 1)
							let day = 'day_' + (this.date1.getDate())
							let resultdata = resData
							if (this.radio === 'month') {
								resultdata = resData[year][month]
							} else if(this.radio === 'day'){
								resultdata = resData[year][month][day]
							} else {// 年的
								resultdata  = resData[year]
							}
							let sum = this.radio+'Sum'
							this.pinnacleInfo.push({
								percentage_level: resultdata.percentage_level?floatFormat(resultdata.percentage_level * 100, 2):0,
								percentage_peak: resultdata.percentage_peak?floatFormat(resultdata.percentage_peak * 100, 2):0,
								percentage_tip: resultdata.percentage_tip?floatFormat(resultdata.percentage_tip * 100, 2):0,
								percentage_valley: resultdata.percentage_valley?floatFormat(resultdata.percentage_valley * 100, 2):0,
								sum_level: resultdata.sum_level?floatFormat(resultdata.sum_level, 2):0,
								sum_peak: resultdata.sum_peak?floatFormat(resultdata.sum_peak, 2):0,
								sum_tip: resultdata.sum_tip?floatFormat(resultdata.sum_tip , 2):0,
								sum_valley: resultdata.sum_valley?floatFormat(resultdata.sum_valley, 2):0,
								total: resultdata[sum]?floatFormat(resultdata[sum], 2):0,
								name:l.loopName
							})
						}else{
							// this.pinnacleInfo = []
							this.pinnacleInfo.push({
								percentage_level: 0,
								percentage_peak: 0,
								percentage_tip:0,
								percentage_valley: 0,
								sum_level: 0,
								sum_peak:0,
								sum_tip: 0,
								sum_valley: 0,
								total:0,
								name:l.loopName
							})

						} 
					})
					
				} catch (e) {
					console.log(e)
				}
			},
			//时段对比
			async ComparisonData(){
				this.loading = true
				let ids = [this.currentLoop.loopId];
				let start
				let end
				let group
				let start2
				let end2
				switch (this.radio) {
					case "day":
						start = dayStart(this.date)
						end = dayEnd(this.date)
						start2 = dayStart(this.twodate)
						end2 = dayEnd(this.twodate)
						group = '1h'
						break
					case "month":
						start = monthStart(this.date)
						end = monthEnd(this.date)
						start2 = monthStart(this.twodate)
						end2 = monthEnd(this.twodate)
						group = '1d'
						break
					case "year":
						start = yearStart(this.date)
						end = yearEnd(this.date)
						start2 = yearStart(this.twodate)
						end2 = yearEnd(this.twodate)
						group = '1m'
						break

				}
				let getlist = [
					{
						start:start,
						end:end,
						time:this.date
					},
					{
						start:start2,
						end:end2,
						time:this.twodate
					}
				]
				this.chartTimeData = []
				let res = await Promise.all(getlist.map(l => INFLUX_QUERY(ids, l.start, l.end, group,["PA_total"])))

				let list = []
				let num = 0
				getlist.forEach((l, i) => {
					let influxData = res[i].data.data.influxData
						influxData.results.forEach(result => {
							let name = dateFormat("YY-mm-dd", l.time)
							if(this.radio=='month'){
								name = dateFormat("YY-mm", l.time)
							}else if(this.radio=='year'){
								name = dateFormat("YY", l.time)
							}
							if(JSON.stringify(result) != "{}"&&result.series.length>0){
								result.series.forEach((serie,index) => {
									let data = []
									serie.values.forEach(val => {
										if(val[4]!=null){
											data.push(floatFormat(val[4],2))
										}else{
											data.push('-')
										}
									})
									list.push({
										name: name,
										type: "line",
										data:data
									})
								})
							}else{
								num++
								list.push({
									name:name,
									type: "line",
									data:[]
								})
							}
							
						})
				})
				if(num==2){
					this.ishow = false
				}else{
					this.ishow = true
				}
				this.chartTimeData = list
				this.loading = false
			},
			//时段对比表格数据
			async ComparisonTableData() {
				let getlist = [
					{
						start:this.date,
					},
					{
						start:this.twodate,
					}
				]
				let res = await Promise.all(getlist.map(l => POWER_ANALYSIS_BY_LOOP(l.start, this.radio, this.currentLoop.loopId)))
				this.pinnacleInfo2 = []
				try {
					getlist.forEach((l, i) => {
						let resData = res[i].data.data.result
						if (JSON.stringify(resData) != "{}") {
							let year = 'year_' + l.start.getFullYear()
							let month = 'month_' + (l.start.getMonth() + 1)
							let day = 'day_' + (l.start.getDate())
							let resultdata = resData
							let time = ""
							if (this.radio === 'month') {
								resultdata = resData[year][month]
								time = dateFormat("YY-mm", l.start)
							} else if(this.radio === 'day'){
								resultdata = resData[year][month][day]
								time = dateFormat("YY-mm-dd", l.start)
							} else {// 年的
								resultdata  = resData[year]
								time = dateFormat("YY", l.start)
							}
							let sum = this.radio+'Sum'
							if(resultdata){
								this.pinnacleInfo2.push({
									percentage_level: resultdata.percentage_level?floatFormat(resultdata.percentage_level * 100, 2):0,
									percentage_peak: resultdata.percentage_peak?floatFormat(resultdata.percentage_peak * 100, 2):0,
									percentage_tip: resultdata.percentage_tip?floatFormat(resultdata.percentage_tip * 100, 2):0,
									percentage_valley: resultdata.percentage_valley?floatFormat(resultdata.percentage_valley * 100, 2):0,
									sum_level: resultdata.sum_level?floatFormat(resultdata.sum_level, 2):0,
									sum_peak: resultdata.sum_peak?floatFormat(resultdata.sum_peak, 2):0,
									sum_tip: resultdata.sum_tip?floatFormat(resultdata.sum_tip, 2):0,
									sum_valley: resultdata.sum_valley?floatFormat(resultdata.sum_valley, 2):0,
									total: resultdata[sum]?floatFormat(resultdata[sum], 2):0,
									time: time
								})
							}else{
								this.pinnacleInfo2.push({
									percentage_level: 0,
									percentage_peak: 0,
									percentage_tip:0,
									percentage_valley: 0,
									sum_level: 0,
									sum_peak:0,
									sum_tip: 0,
									sum_valley: 0,
									total:0,
									time: time
								})
							}
							
						}else{
							// this.pinnacleInfo2.push({
							// 	percentage_level: 0,
							// 	percentage_peak: 0,
							// 	percentage_tip:0,
							// 	percentage_valley: 0,
							// 	sum_level: 0,
							// 	sum_peak:0,
							// 	sum_tip: 0,
							// 	sum_valley: 0,
							// 	total:0,
							// 	time: dateFormat("YY-mm-dd", l.start)
							// })
						} 
					})
					
				} catch (e) {
					console.log(e)
				}
			},
			initPowerTimeData() {
				if (this.routeName === "Pinnacle") {
					this.radio = "month";
				} else {
					this.allNodeData = [];
				}
			},
			perD() {
				this.date1 = perDay(this.date1);
			},
			nextD() {
				this.date1 = nextDay(this.date1);
			},
			perM() {
				this.date1 = perMonth(this.date1);
			},
			nextM() {
				this.date1 = nextMonth(this.date1);
			},
			perY() {
				this.date1 = perYear(this.date1);
			},
			nextY() {
				this.date1 = nextYear(this.date1);
			},

		},
	};
</script>

<style scoped lang="less">
	/deep/.el-picker-panel{
		z-index: 1;
		position: relative;
	}
	.footer {
		.info {
            padding: 39px 24px;
            align-items: flex-start;
			.item {
				width: 20%;

                .row {
                    margin-bottom: 22px;
                }

				.k {
					margin-right: 9px;
				}

				.v {
					color: rgba(13, 148, 255, 1) !important;
				}

				.txt {
					font-size: 18px;
					font-weight: 400;
					color: #333333;
				}

				.title {
					margin-bottom: 23px;

				}
			}
		}

		.tit {
			height: 57px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #333333;
			line-height: 57px;
			border-bottom: 1px solid rgba(0, 0, 0, .15);
			padding: 0 25px;
		}
	}

	.tit-com {
		font-size: 18rem;
		font-weight: 400;
		color: #333333;
		border-left: 4px solid rgba(13, 148, 255, 1);
		height: 18px;
		line-height: 18px;
		padding-left: 17px;
	}

	.radio-3 {
		span {
			font-size: 18px;
			font-weight: 400;
			color: #333333;
		}

		div {
			width: 33.33%;
			height: 40px;
			line-height: 40px;
			text-align: center;
			font-size: 18rem;
			font-weight: 400;
			color: #333333;
			border: 1px solid rgba(51, 51, 51, .15);
			cursor: pointer;

			&:hover, &.active {
				color: rgba(13, 148, 255, 1);
				border: 1px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.loadfactor {
		width: 120rem;
		text-align: center;
	}

	.el-dropdown-menu__item.active {
		color: #0d94ff;
	}

	.alarming {
		// color: #fd4238 !important;
	}

	.breaker-data-1 {
		.h(968) !important;
	}

	.tab-breaker {
		> div {
			font-size: 18rem;
			font-weight: 400;
			color: #999999;
			border-top: 2px solid #ffffff;
			padding-top: 23rem;
			margin-right: 25rem;

			&.active {
				font-weight: bold;
				color: #0d94ff;
				border-top: 2px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.transformerClass {
		.h(570) !important;

		.echarts {
			.left {
				.h(400) !important;
			}
		}

		.max-right {
			.h(400) !important;
		}
	}

	.transformer-data {
		padding: 0 24rem;
		background-color: #fff;
		.h(389);

		.card-list {
			.card-item {
				.w(298);
				.h(254);
				padding: 0rem 24rem;
				border-radius: 4px;
				background-color: rgba(0, 43, 102, 0.04);
				position: relative;

				h5 {
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}

				span {
					font-size: 24rem;
					font-weight: bold;
					color: #0d94ff;
					// margin-top: 8rem;
				}

				.val-details {
					width: 100%;
					justify-content: space-between;
					// margin-top: 20rem;

					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999 !important;
					}
				}
			}

			.type-2 {

				// padding-top: 70rem;
				span {
					margin-top: 25rem;
				}
			}

			.type-3 {
				align-items: flex-start;
				padding: 0 20rem;

				h4 {
					font-size: 24px;
					font-weight: bold;
					color: #f5aa00;
				}

				h5.sub-title {
					font-size: 17rem;
					color: rgba(51, 51, 51, 1);
					font-weight: bold;
				}

				p {
					font-size: 14rem;
					color: rgba(153, 153, 153, 1);
				}

				h5,
				p {
					line-height: 32rem;
				}
			}

			.type-4 {
				// padding-bottom: 12px;

				.other {
					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999;
					}
				}
			}

			.type-1 .column-center,
			.type-4 .column-center {
				height: 90rem;
				// width: 100%;
			}

			.type-1 .column-center:first-child,
			.type-4 .column-center:first-child {
				// height: 135rem;
				// padding-top: 20rem;
				// justify-content: initial;
				// width: 100%;
			}

			.other {
				position: absolute;
				bottom: 12rem;
			}
		}

		.tab {
			span {
				display: inline-block;

				min-width: 88rem;
				line-height: 64rem;
				border-top: 2px solid #ffffff;
				font-size: 18rem;
				text-align: center;
				margin-right: 29rem;
				transition: all 0.3s;
				font-weight: 400;
				color: #999999;

				&.active {
					border-top: 2px solid rgba(13, 148, 255, 1);
					color: #0d94ff;
					font-weight: bold;
				}
			}
		}
	}

	.tree {
		width: 100%;
		background-color: #fff;
		transition: all 0.5s;
		overflow: hidden;
		box-shadow: 0 0 2px 0 #8c939d;

		.data {
			width: 100%;
			margin-top: 8rem;
			height: 100%;
		}

		.option {
			width: 100%;
			.h(40);
			border-bottom: 1px solid rgba(0, 0, 0, 0.06);
			padding: 0 16rem;
			font-size: 14rem;
			font-weight: 300;
			color: #333333;
			line-height: 36rem;

			.all {
				cursor: pointer;

				img {
					// width: 16rem;
					// height: 16rem;
					margin-right: 8rem;
				}

				span {
					&:hover {
						color: rgba(13, 148, 255, 1);
					}
				}
			}

			> span {
				cursor: pointer;
				color: rgba(13, 148, 255, 1);
			}
		}
	}

	.nodes-tree {
		.w(260);
		height: 40px;
		margin-right: 8rem;
		background-color: #ffffff;
	}

	.report {
		margin-top: 24rem;
		.h(815);
	}

	.export {
		margin-left: 23rem;

		img {
			margin-right: 7rem;
		}

		span {
			font-size: 18rem;
			font-weight: 500;
			color: #333333;
		}
	}

	.btn {
		.w(96);
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 18px;
		font-weight: 400;
		color: #ffffff;
		background-color: #0d94ff;
		cursor: pointer;
		border-radius: 4rem;
		overflow: hidden;
		padding: 0px;
	}

	.per,
	.next {
		background-color: #fff;
		font-size: 18rem;
		color: #666666;
		font-weight: 400;
		border: 1px solid rgba(0, 0, 0, 0.15);

		&:hover {
			background-color: #0d94ff;
			color: #ffffff;
		}
	}

	.el-button.is-plain:hover {
		background-color: #0d94ff !important;
		color: #ffffff !important;
		transition: 0s;
	}

	.el-button.is-active,
	.el-button.is-plain:active,
	.el-button.is-plain:focus {
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: #666666;
	}

	.el-button.is-disabled:hover {
		background-color: #ffffff !important;
		color: #c0c4cc !important;
		transition: 0s;
	}

	.per {
		// margin-left: 24rem;
	}

	.next {
		margin-left: 8rem;
	}

	.node-select,
	.dateSelect {
		.w(260) !important;
		// .h(40) !important;
	}

	.node-select {
		margin-right: 24rem;
	}
	
	.data-table {
		padding: 24rem;
		background-color: #fff;
		.w(1265);
		.h(908);

		.menu {
			// margin-top: 24rem;
			font-size: 18rem;
			.export {
				margin-left: 61rem;
			}

			.radio {
				margin-left: 24rem;

				.el-radio {
					margin-right: 20rem;
				}
			}
			span{
				display: inline-block;
				vertical-align: middle;
			}
		}

		.title {
			font-size: 18rem;
			font-weight: bold;
			color: #333333;
		}
	}

	.diagram {
		.w(1265);
		.h(618);
		margin-top: 8rem;
		background-color: #fff;
		padding-left: 24rem;

		// display: flex;
		.exetext {
			.w(728);
			display: flex;
			align-items: center;
			justify-content: space-between;

			.exetext1 {
				display: flex;
				align-items: center;
			}
		}

		.left {
			width: 100%;
			.h(480);
		}

		.echarts {
			width: 100%;

			.left {
				width: 100%;
				.h(460);
			}

			.max-right {
				.w(272);
				// height: 380px;
				.h(460);
				margin-right: 24rem;

				.row-max {
					width: 100%;
					background-color: rgba(0, 43, 102, 0.02);
					// height: 88px;
					margin-bottom: 10px;

					.details {
						.w(176);
						height: 100%;
						padding: 12rem 0;

						span {
							margin-right: 8rem;
							color: rgba(13, 148, 255, 1);
							font-size: 16rem;

							&:first-child {
								color: #333333;
							}
						}
					}

					.max-name {
						height: 100%;
						.w(96);
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}
				}
			}
		}

		.showMax {
			div.left {
				.w(920) !important;
			}
		}

		.tab {
			width: 100%;
			.h(438);
			margin-top: 25rem;
		}

		.content {
			margin-top: 10rem;

			.dateSelect {
				font-size: 18rem;
				color: #000000 !important;
				margin-right: 8rem;
			}

			.max {
				.w(100);
				margin-left: 127rem;
			}

			.hose {
				display: flex;
				align-items: center;
			}
		}

		.select1 {
			margin-right: 27rem;
			font-size: 18rem;
			font-weight: 400;
			color: #333333;
			padding-top: 23rem;
			border-top: 2rem solid rgba(0, 0, 0, 0);
		}

		.select {
			> div {
				cursor: pointer;
				margin-right: 27rem;
				font-size: 18rem;
				font-weight: 400;
				color: #999999;
				padding-top: 21rem;
				border-top: 2rem solid rgba(0, 0, 0, 0);

				&.active {
					color: #0d94ff;
					font-weight: bold;
					border-top: 2rem solid #0d94ff;
				}
			}
		}
	}

	.real-data1 {
		.realLeft {
			padding: 24rem;
			.w(524);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);

			.status {
				width: 100%;
				.h(220);
				margin-top: 57rem;
				background-color: #fff;
				display: flex;
				justify-content: space-between;
			}

			.operation {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(71);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus {
						font-size: 38rem;
						font-weight: bold;
						color: #68d86a;
					}

					.boxStatusOred {
						font-size: 38rem;
						font-weight: bold;
						color: #fd4238;
					}

					.boxStatusOBack {
						font-size: 38rem;
						font-weight: bold;
						color: #0d94ff;
					}
				}
			}

			.operation1 {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					// .w(89);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus1 {
						// margin: auto;
						font-size: 18rem;

						.ax {
							width: 90%;
							margin: auto;
							display: flex;
							line-height: 28px;
							// justify-content: space-between;
							align-items: center;
							white-space: nowrap;
							font-size: 18rem;

							// p {
							//     font-size: 18rem;
							//     color: #333333;
							//     // white-space: nowrap
							// }

							.ax-2 {
								// display: flex;
								// justify-content: space-between;
								font-weight: 400;
								color: #0d94ff;
								font-size: 18rem;
								margin-right: 5rem
							}
						}
					}
				}
			}
		}

		.realRight {
			.w(724);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
			padding: 24rem;

			.foune-1 {
				display: flex;
				justify-content: space-between;

				// background-color: red;
				.tit-1 {
					display: flex;
					.w(170);
					justify-content: space-between;
					.h(69);
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}
			}

			// .foune-2::-webkit-scrollbar {
			// width: 1px !important;
			// }
			.foune-2 {
				width: 100%;
				height: 80%;
				overflow-y: scroll;

				.oLi {
					width: 50%;
					height: 11%;
					background-color: #fff;
					// display: flex;
					border-top: rgba(0, 0, 0, 0.06) 1px solid;
					// align-items: center;
					float: left;

					.oli-Div {
						width: 100%;
						height: 100%;
						font-size: 18rem;
						display: flex;
						justify-content: space-between;
						padding-right: 35%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;
		}
	}

	.real-data {
		background-color: #ffffff;
		padding: 24rem;
		.h(342);

		.total-data {
			margin-top: 23rem;
			background: rgba(0, 43, 102, 0.04);
			border-radius: 4px;
			// padding-left: 8rem;
			line-height: 36rem;

			font-size: 18rem;
			font-weight: 400;
			color: #333333;

			.total-item {
				background-color: #fff;
				height: 100%;
			}

			.total-data-close {
				margin-left: 24rem;
				color: #fd4238;
				font-weight: bold;
			}

			.total-data-open {
				margin-left: 24rem;
				color: #68d86a;
				font-weight: bold;
			}
		}

		.PowerQuality-none {
			.w(280) !important;

			.val {
				.w(145) !important;
			}

			.key {
				width: auto !important;
				margin-left: 25rem;
				margin-right: 32rem;
			}
		}

		.data {
			.w(395);

			.details {
				.h(132);
				justify-content: space-between;
				margin-top: 23rem;

				.row {
					margin-bottom: 18rem;
				}

				.active {
					span {
						color: #fd4238;
					}
				}

				.key,
				.val {
					font-size: 14rem;
					color: #333333;
					font-weight: 400;
				}

				.key {
					.w(120);
					/*margin-right: 4rem;*/
				}

				.val {
					color: #0d94ff;
					.w(263);

					span {
						display: inline-block;
						width: 25%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;

			.location-right {
				.w(492);
				.h(236);
				position: absolute;
				right: 69rem;
				background-color: red;
				padding: 36rem 0 0 38rem;
				background: rgba(0, 43, 102, 0.04);

				.location-and {
					display: flex;
					align-items: center;
					height: 34rem;

					.location-img {
						width: 34rem;
						height: 34rem;
						margin-right: 5px;
					}

					img {
						width: 34rem;
						height: 34rem;
					}
				}

				.location-title {
					// font-size: 24px;

					font-size: 28rem;
					font-weight: bold;
					color: #68d86a;

					line-height: 30px;
				}

				.location-orag {
					font-size: 28rem;
					font-weight: bold;
					color: #f5aa00;

					line-height: 30px;
				}

				.location-item {
					margin-top: 35rem;
					.w(420);
					height: 63px;
					font-size: 16rem;
					font-weight: 400;
					color: #999999;
					word-wrap: break-word;
					word-break: break-all;
					overflow: hidden;
					/*这个参数根据需求来决定要不要*/
				}
			}
		}

		.name {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			border-bottom: 1px solid rgba(0, 0, 0, 0.15);
			padding-bottom: 8rem;
			margin-top: 20rem;
			padding-left: 17rem;
		}
	}

	.Loopst {
		width: 475rem;
	}

	.breaker {
		display: flex;
		width: 100%;
		height: 100%;
		// background-color: rgba(0, 43, 102, 0.04);
		padding-left: 8rem;

		span {
			font-size: 18rem;
			font-weight: bold;
		}

		.k {
			color: #333333;
			margin-right: 24rem;
		}

		.v {
			color: red;
		}

		.Handcart {
			color: #0d94ff;
		}

		.sate {
			padding-left: 325rem;
		}
	}

	.ored {
		margin-left: 24rem;
		color: #fd4238;
		font-weight: bold;
	}

	.oglad {
		margin-left: 24rem;
		color: #68d86a;
		font-weight: bold;
	}

	.obalck {
		color: #0d94ff;
		font-weight: bold;
	}
</style>
